export const PLAYER_BRIGHTNESS_NEUTRAL_LEVEL = 0.5

export function clampPlayerLevel(value: number) {
    return Math.max(0, Math.min(Number.isFinite(value) ? value : 0, 1))
}

export function resolveVideoBrightness(level: number) {
    const normalized = clampPlayerLevel(level)
    if (normalized <= PLAYER_BRIGHTNESS_NEUTRAL_LEVEL) {
        return normalized / PLAYER_BRIGHTNESS_NEUTRAL_LEVEL
    }
    const boostProgress = (normalized - PLAYER_BRIGHTNESS_NEUTRAL_LEVEL) / (1 - PLAYER_BRIGHTNESS_NEUTRAL_LEVEL)
    return 1 + boostProgress * 0.3
}
